export default __webpack_public_path__ + "static/media/leaguePro.26ff857a.jpg";